import React from 'react';
import services from '../data/services';
import './Services.css';

const icons = {
  integration: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 48 48">
      <rect x="6" y="6" width="36" height="36" rx="3"/>
      <path d="M14 24h20M24 14v20"/>
      <circle cx="24" cy="24" r="5"/>
    </svg>
  ),
  building: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 48 48">
      <path d="M8 40V20L24 8l16 12v20"/>
      <rect x="18" y="28" width="12" height="12"/>
      <path d="M18 28v-6h12v6"/>
    </svg>
  ),
  power: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 48 48">
      <path d="M24 6v6M24 36v6M6 24h6M36 24h6"/>
      <circle cx="24" cy="24" r="8"/>
      <path d="M12 12l4 4M32 32l4 4M12 36l4-4M32 16l4-4"/>
    </svg>
  ),
  datacenter: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 48 48">
      <rect x="6" y="14" width="36" height="24" rx="2"/>
      <path d="M16 14V10M32 14V10M6 22h36"/>
    </svg>
  ),
  commissioning: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 48 48">
      <path d="M24 6L6 18v6l18 12 18-12v-6L24 6z"/>
      <path d="M6 24l18 12 18-12"/>
    </svg>
  ),
  support: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="18"/>
      <path d="M24 14v10l8 4"/>
    </svg>
  ),
};

export default function Services() {
  return (
    <section id="services" className="services-section">
      <div className="section-inner">
        <div className="section-label">What We Do</div>
        <h2>Our Services</h2>
        <p className="section-sub">
          From initial assessment through full system commissioning, we deliver integration
          services built for the demands of modern facilities.
        </p>
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{icons[service.icon]}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
